import {byProp, numericCompareAsc} from '@lib/utils';
import {createEntityAdapter} from '@reduxjs/toolkit';
import {Floor} from '../entities';

export const floorsAdapter = createEntityAdapter<Floor>({
  selectId: (floor) => floor.id,
  sortComparer: byProp('number', numericCompareAsc),
});
